/**
 * Labstep
 *
 * @module components/User/Form/ShowEdit/Biography
 * @desc Show edit for user biography
 */

import { fieldUserBiography } from 'labstep-web/components/User/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Pre } from 'labstep-web/core/Pre';
import type React from 'react';
import type { IUserFormShowEditBiographyProps } from './types';

export const UserFormShowEditBiography: React.FC<
  IUserFormShowEditBiographyProps
> = ({ user }) => (
  <ShowEditText
    optimistic
    entityName={user.entityName}
    entity={user}
    field={fieldUserBiography}
    id={user.id}
  >
    <Pre>{user.biography}</Pre>
  </ShowEditText>
);
